import { useDropdownWheelScrollFix } from '@/shared/hooks/useDropdownWheelScrollFix'

import { Providers } from './providers'
import { AppRouter } from './router'
import { BootGate } from './BootGate'

export function App() {
  useDropdownWheelScrollFix()
  return (
    <Providers>
      <BootGate>
        <AppRouter />
      </BootGate>
    </Providers>
  )
}
